import OtherPage from 'containers/Admin/OtherPage';
import UserManagement from 'containers/Admin/UserManagement';
import { addComponentsToRoutes } from 'services/common';
import routes from './routesOnNav';
import DedicatedIp from '../../containers/Admin/DedicatedIp';
import MonitoringDomain from '../../containers/Admin/MonitoringDomain';
import RedisCacheInvalidation from '../../containers/Admin/RedisCacheInvalidation';
import DomainWarmUp from '../../containers/Admin/DomainWarmUp';
import BugFeatureReports from 'containers/Admin/BugFeatureReports';
import AuthorizedDomains from 'containers/Admin/AuthorizedDomains';
import EmailQueueMonitoring from '../../containers/Admin/EmailQueueMonitoring';
import SIBDomains from 'containers/Admin/SIBDomains';
import IpPoolMapping from 'containers/Admin/IpPoolMapping';

const components = {
  '/admin/other': OtherPage,
  '/admin/user-management': UserManagement,
  '/admin/dedicated-ip': DedicatedIp,
  '/admin/domain-monitoring': MonitoringDomain,
  '/admin/domain-warmup': DomainWarmUp,
  '/admin/domain-receiver-provider-ip-mapping': IpPoolMapping,
  '/admin/purge-redis-cache': RedisCacheInvalidation,
  '/admin/bug-feature-reports': BugFeatureReports,
  '/admin/authorized-domains': AuthorizedDomains,
  '/admin/email-queue-monitoring': EmailQueueMonitoring,
  '/admin/sib-domains': SIBDomains,
};

export default addComponentsToRoutes(routes, components);
